<template>
  <vxe-toolbar>
    <template #buttons>
      <el-radio-group v-model="viewMode" size="small">
        <el-radio-button label="table"
          ><i class="fa fa-table" aria-hidden="true"></i> 表格</el-radio-button
        >
        <el-radio-button label="chart"
          ><i class="fa fa-area-chart" aria-hidden="true"></i>
          图表</el-radio-button
        >
      </el-radio-group>
    </template>
    <template #tools>
      <el-upload
        action="#"
        accept=".xls,.xlsx,.csv"
        :http-request="excelImport"
        :show-file-list="false"
      >
        <el-button type="primary" size="small" plain>
          导入温度数据 <i class="el-icon-upload"></i>
        </el-button>
      </el-upload>
      <el-dropdown szie="small" class="ml-2" @command="exportCommand">
        <el-button type="primary" size="small" plain>
          导出为
          <i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="PDF">PDF</el-dropdown-item>
          <el-dropdown-item command="EXCEL">EXCEL</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </template>
  </vxe-toolbar>
</template>
<script>
export default {
  props: {
    mode: String,
  },
  data() {
    return {
      viewMode: this.mode || 'table',
    }
  },
  watch: {
    viewMode(val) {
      this.$emit('update:mode', val)
    },
  },
  methods: {
    exportCommand(command) {
      switch (command) {
        case 'EXCEL':
          this.$emit('excelExport')
          break
        case 'PDF':
          this.$emit('pdfExport')
          break
      }
    },
    excelImport({ file }) {
      this.$emit('excelImport', file)
    },
  },
}
</script>
